import React, { useState } from "react";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import "../Components/NavigatBar.css";
import Logo from "../Images/Asset 2-100.jpg";

/* ─── Dropdown hook — closes on item click too ── */
function useDropdown() {
  const [open, setOpen] = useState(false);
  return {
    show: open,
    onMouseEnter: () => setOpen(true),
    onMouseLeave: () => setOpen(false),
    onToggle: (isOpen) => setOpen(isOpen),
    close: () => setOpen(false),
  };
}

/* ─── Internal nav link — closes dropdown and mobile menu on click ─ */
function NavItem({ to, children, onClose, onCollapseClose }) {
  const history = useHistory();
  return (
    <NavDropdown.Item
      as="button"
      className="home"
      onClick={() => {
        onClose?.(); // close the dropdown
        onCollapseClose?.(); // collapse mobile navbar
        history.push(to);
      }}
    >
      {children}
    </NavDropdown.Item>
  );
}

function NavigatBar() {
  const [expanded, setExpanded] = useState(false);

  const aboutUs = useDropdown();
  const services = useDropdown();
  const thematic = useDropdown();
  const team = useDropdown();
  const publicity = useDropdown();

  const closeAll = () => {
    setExpanded(false);
  };

  return (
    <header>
      <Navbar
        className="navba"
        collapseOnSelect
        expand="lg"
        fixed="top"
        expanded={expanded}
        onToggle={(val) => setExpanded(val)}
      >
        <Container>
          {/* Logo */}
          <Navbar.Brand
            as={Link}
            to="/"
            aria-label="CIRCODU — go to homepage"
            onClick={closeAll}
          >
            <img
              src={Logo}
              alt="CIRCODU logo"
              width="100"
              height="63"
              loading="eager"
              fetchpriority="high"
              style={{
                height: "auto",
                width: "100px",
                boxShadow: "none",
                borderRadius: "5%",
                transition: "box-shadow 0.3s ease-in-out",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.boxShadow =
                  "2px 2px 2px 2px rgba(0, 255, 157, 0.4)")
              }
              onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => setExpanded((prev) => !prev)}
          />

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="m-auto">
              {/* Home */}
              <Nav.Link
                as={Link}
                to="/"
                className="home active"
                onClick={closeAll}
              >
                Home
              </Nav.Link>

              {/* About Us */}
              <NavDropdown
                title="About Us"
                id="nav-dropdown-about"
                className="dropdown home"
                show={aboutUs.show}
                onMouseEnter={aboutUs.onMouseEnter}
                onMouseLeave={aboutUs.onMouseLeave}
                onToggle={aboutUs.onToggle}
              >
                <NavItem
                  to="/about-us/who-we-are"
                  onClose={aboutUs.close}
                  onCollapseClose={closeAll}
                >
                  Who We Are
                </NavItem>
                <NavItem
                  to="/about-us/what-we-do"
                  onClose={aboutUs.close}
                  onCollapseClose={closeAll}
                >
                  What We Do
                </NavItem>
                <NavDropdown.Divider />
                <NavItem
                  to="/about-us/our-clients-partners"
                  onClose={aboutUs.close}
                  onCollapseClose={closeAll}
                >
                  Clients and Partners
                </NavItem>
              </NavDropdown>

              {/* Our Services */}
              <NavDropdown
                title="Our Services"
                id="nav-dropdown-services"
                className="dropdown home"
                show={services.show}
                onMouseEnter={services.onMouseEnter}
                onMouseLeave={services.onMouseLeave}
                onToggle={services.onToggle}
              >
                <NavItem
                  to="/our-services/consultancy"
                  onClose={services.close}
                  onCollapseClose={closeAll}
                >
                  Consultancy
                </NavItem>
                <NavItem
                  to="/our-services/research"
                  onClose={services.close}
                  onCollapseClose={closeAll}
                >
                  Research Projects
                </NavItem>
                <NavItem
                  to="/our-services/monitoring-and-evaluation"
                  onClose={services.close}
                  onCollapseClose={closeAll}
                >
                  Monitoring &amp; Evaluation
                </NavItem>
                <NavItem
                  to="/our-services/cookstoves-and-fuel-testing"
                  onClose={services.close}
                  onCollapseClose={closeAll}
                >
                  Cookstoves &amp; Fuel Testing
                </NavItem>
                <NavDropdown.Divider />
                <NavItem
                  to="/our-services/capacity-building"
                  onClose={services.close}
                  onCollapseClose={closeAll}
                >
                  Capacity Building
                </NavItem>
              </NavDropdown>

              {/* Our Thematic Areas */}
              <NavDropdown
                title="Our Thematic Areas"
                id="nav-dropdown-thematic"
                className="dropdown home"
                show={thematic.show}
                onMouseEnter={thematic.onMouseEnter}
                onMouseLeave={thematic.onMouseLeave}
                onToggle={thematic.onToggle}
              >
                <NavItem
                  to="/our-thematic-areas/energy"
                  onClose={thematic.close}
                  onCollapseClose={closeAll}
                >
                  Energy
                </NavItem>
                <NavItem
                  to="/our-thematic-areas/public-health"
                  onClose={thematic.close}
                  onCollapseClose={closeAll}
                >
                  Public Health
                </NavItem>
                <NavItem
                  to="/our-thematic-areas/water-and-sanitation"
                  onClose={thematic.close}
                  onCollapseClose={closeAll}
                >
                  Water &amp; Sanitation
                </NavItem>
                <NavItem
                  to="/our-thematic-areas/waste-management"
                  onClose={thematic.close}
                  onCollapseClose={closeAll}
                >
                  Waste Management
                </NavItem>
                <NavItem
                  to="/our-thematic-areas/agricultural-management"
                  onClose={thematic.close}
                  onCollapseClose={closeAll}
                >
                  Agricultural Management
                </NavItem>
              </NavDropdown>

              {/* The Team */}
              <NavDropdown
                title="The Team"
                id="nav-dropdown-team"
                className="dropdown home"
                show={team.show}
                onMouseEnter={team.onMouseEnter}
                onMouseLeave={team.onMouseLeave}
                onToggle={team.onToggle}
              >
                <NavItem
                  to="/the-team/top-management"
                  onClose={team.close}
                  onCollapseClose={closeAll}
                >
                  Top Management
                </NavItem>
                <NavItem
                  to="/the-team/the-staff-team"
                  onClose={team.close}
                  onCollapseClose={closeAll}
                >
                  The Staff Team
                </NavItem>
              </NavDropdown>
            </Nav>

            <Nav>
              {/* Publicity */}
              <NavDropdown
                title="Publicity"
                id="nav-dropdown-publicity"
                className="dropdown home"
                show={publicity.show}
                onMouseEnter={publicity.onMouseEnter}
                onMouseLeave={publicity.onMouseLeave}
                onToggle={publicity.onToggle}
              >
                <NavItem
                  to="/publicity/gallery"
                  onClose={publicity.close}
                  onCollapseClose={closeAll}
                >
                  Photo Gallery
                </NavItem>
                <NavDropdown.Item
                  href="https://www.youtube.com/@CIRCODU"
                  className="home"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeAll}
                >
                  Video Gallery
                </NavDropdown.Item>
                <NavItem
                  to="/publicity/news-and-events"
                  onClose={publicity.close}
                  onCollapseClose={closeAll}
                >
                  News &amp; Events
                </NavItem>
              </NavDropdown>

              {/* Contact */}
              <Nav.Link
                as={Link}
                to="/contact-us"
                className="home"
                onClick={closeAll}
              >
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}

export default NavigatBar;
